export enum Steps {
  START = 'start',
  MOD = 'mod',
  ROASTIN = 'roastin',
  ACIDITY = 'acidity',
  AROMA = 'aroma',
  FLAVOUR = 'flavour',
  AFTERTASTE = 'aftertaste',
  AMOUNT = 'amount',
  LABEL = 'label',
  SUMMARY = 'summary',
  PORTION = 'portion',
}
